import React, { useState, useEffect } from "react";
import { useFetch } from "services/hooks/useFetch";
import * as Mui from "@mui/material";
import { checkFirstLevelApproverPermission } from "services/utils/HelperFunction";
import { setGlobalSearchValue } from "services/Redux/userToken";
import { themes, defaultAllSelection } from "services/constants";
import { CustomAutoComplete } from "components/CustomComponents/CustomAutoComplete";
import { CustomAutoCompleteWithLogo } from "components/CustomComponents/CustomAutoCompleteWithLogo";
import { showToast } from "services/utils/Status";
import sessionHandling from "services/utils/notificationUtils";
import { useSelector, useDispatch } from "react-redux";
import { Apply } from "./Apply";
import { Approve } from "./Approve";
import { History } from "./History";
import { ViewLoan } from "./ViewLoan";
import {
  setDepartmentId,
  setDepartmentName,
} from "services/Redux/userManagament";
import { ApproveLoan } from "./ApproveLoan";
export const Loans = () => {
  const { domain, token, userDetails, userScreenAccess } = useSelector(
    (state) => state.tokenReducer
  );
  const [viewLoanDetails, setViewLoanDetails] = useState({});
  const [viewLoan, setViewLoan] = useState(false);
  const [showApprove, setShowApprove] = useState(false);
  const [loanScreen, setLoanScreen] = useState("Approve");
  const [selectComponent, setSelectComponent] = useState("Approve");
  const [userName, setUserName] = useState("All");
  const [departmentChange, setDepartmentChange] = useState(true);
  const [userChange, setUserChange] = useState(true);
  const [userId, setUserId] = useState(defaultAllSelection);
  const [departmentData, setDepartmentData] = useState([]);
  const [showAutoCompleteAvathar, setShowAutoCompleteAvathar] = useState(false);

  const dispatch = useDispatch();

  const { departmentId, departmentName } = useSelector(
    (state) => state.userReducer
  );
  const handleChange = (event, newAlignment) => {
    if (newAlignment) {
      setLoanScreen(newAlignment);
      dispatch(setGlobalSearchValue(""));
      setViewLoan(false);
      setShowApprove(false);
    }
  };
  const { result: membersData, setLoad: reCallMemberApi } = useFetch(
    `${domain}get-department-based-user/?department_id=${departmentId}&user_id=${userDetails.id}`
  );

  const renderComponent = () => {
    switch (selectComponent) {
      case "Approve":
        return (
          <Approve
            departmentId={departmentId}
            departmentChange={departmentChange}
            setDepartmentChange={setDepartmentChange}
            loanScreen={loanScreen}
            setViewLoanDetails={setViewLoanDetails}
            userChange={userChange}
            setUserChange={setUserChange}
            setShowApprove={setShowApprove}
            userId={userId}
          />
        );
      case "History":
        return (
          <History
            loanScreen={loanScreen}
            departmentId={departmentId}
            departmentChange={departmentChange}
            setDepartmentChange={setDepartmentChange}
            userChange={userChange}
            setUserChange={setUserChange}
            userId={userId}
            setViewLoanDetails={setViewLoanDetails}
            setViewLoan={setViewLoan}
          />
        );
      case "Apply":
        return <Apply />;
      default:
        break;
    }
  };

  useEffect(() => {
    dispatch(setDepartmentName("All"));
    dispatch(setDepartmentId(99999));
  }, [dispatch]);

  useEffect(() => {
    const fetchDepartmentData = async () => {
      try {
        const response = await fetch(
          `${domain}get-department/?user_id=${userDetails.id}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `token ${token}`,
            },
          }
        );
        const res = await response.json();
        if (response.ok) {
          const allDepartment = {
            id: defaultAllSelection,
            department_name: "All",
          };
          setDepartmentData([allDepartment, ...res]);
        } else if (response.status === 409) {
          sessionHandling();
        } else {
          throw new Error(res.error);
        }
      } catch (error) {
        showToast("error", error.message);
      }
    };
    fetchDepartmentData();
  }, [domain, token, userDetails.id]);

  const updateDepartmentName = (event, data) => {
    if (data) {
      dispatch(setDepartmentName(data.label));
      dispatch(setDepartmentId(data.id));
      localStorage.setItem("approveLeaveDepartmentId", data.id);
      localStorage.setItem("approveLeaveDepartmentName", data.label);
      setUserName("All");
      setUserId(defaultAllSelection);
      setDepartmentChange(true);
      reCallMemberApi(true);
    }
  };

  const updateUserName = (event, data) => {
    if (data) {
      setUserName(data);
      setUserId(data.user_id);
      setUserChange(true);
      reCallMemberApi(true);
      setShowAutoCompleteAvathar(false);
    } else {
      setShowAutoCompleteAvathar(true);
    }
  };

  return (
    <React.Fragment>
      {showApprove || viewLoan ? null : (
        <Mui.Grid container sx={{ paddingTop: 5, paddingLeft: 3 }}>
          <Mui.Grid item xs={5}>
            <Mui.Box
              sx={{
                display: "flex",
                alignItems: "center",
                width: 500,
                height: 55,
                position: "relative",
                overflow: "hidden",
              }}
            >
              <Mui.ToggleButtonGroup
                value={loanScreen}
                exclusive
                onChange={handleChange}
                sx={{
                  display: "flex",
                  width: "100%",
                  height: "100%",
                  position: "absolute",
                  borderRadius: "30px",
                  backgroundColor: themes.lightBrown,
                }}
              >
                <Mui.ToggleButton
                  value="Approve"
                  sx={{
                    flex: 1,
                    textTransform: "capitalize",
                    fontSize: 18,
                    borderRadius: "30px",
                    fontWeight: 600,
                    border: "none",
                    color:
                      loanScreen === "Approve"
                        ? themes.whiteColor
                        : themes.headLine,
                    backgroundColor:
                      loanScreen === "Approve"
                        ? themes.headLine
                        : themes.lightBrown,
                    "&.Mui-selected": {
                      backgroundColor: themes.headLine,
                      color: themes.whiteColor,
                      "&:hover": {
                        backgroundColor: themes.headLine,
                        color: themes.whiteColor,
                      },
                      borderRadius: "30px",
                      "&.Mui-selected": {
                        borderRadius: "30px",
                      },
                    },
                    "&:hover": {
                      backgroundColor:
                        loanScreen === "Approve"
                          ? themes.headLine
                          : themes.lightBrown,
                      color:
                        loanScreen === "Approve"
                          ? themes.whiteColor
                          : themes.headLine,
                    },
                  }}
                  onClick={() => {
                    setSelectComponent("Approve");
                  }}
                >
                  Approve
                </Mui.ToggleButton>
                <Mui.ToggleButton
                  value="History"
                  sx={{
                    flex: 1,
                    textTransform: "capitalize",
                    borderRadius: !checkFirstLevelApproverPermission(
                      userScreenAccess?.module_details,
                      "Approve",
                      "Loans"
                    )
                      ? "30px"
                      : "0px",
                    fontSize: 18,
                    fontWeight: 600,
                    border: "none",
                    color:
                      loanScreen === "History"
                        ? themes.whiteColor
                        : themes.headLine,
                    backgroundColor:
                      loanScreen === "History"
                        ? themes.headLine
                        : themes.lightBrown,
                    "&.Mui-selected": {
                      backgroundColor: themes.headLine,
                      color: themes.whiteColor,
                      "&:hover": {
                        backgroundColor: themes.headLine,
                        color: themes.whiteColor,
                      },
                      borderRadius: "30px",
                      "&.Mui-selected": {
                        borderRadius: "30px",
                      },
                    },
                    "&:hover": {
                      backgroundColor:
                        loanScreen === "History"
                          ? themes.headLine
                          : themes.lightBrown,
                      color:
                        loanScreen === "History"
                          ? themes.whiteColor
                          : themes.headLine,
                    },
                  }}
                  onClick={() => {
                    setSelectComponent("History");
                  }}
                >
                  History
                </Mui.ToggleButton>
                {checkFirstLevelApproverPermission(
                  userScreenAccess?.module_details,
                  "Approve",
                  "Loans"
                ) ? (
                  <Mui.ToggleButton
                    value="Apply"
                    sx={{
                      flex: 1,
                      textTransform: "capitalize",
                      fontSize: 18,
                      borderRadius: "30px",
                      fontWeight: 600,
                      border: "none",
                      color:
                        loanScreen === "Apply"
                          ? themes.whiteColor
                          : themes.headLine,
                      backgroundColor:
                        loanScreen === "Apply"
                          ? themes.headLine
                          : themes.lightBrown,
                      "&.Mui-selected": {
                        backgroundColor: themes.headLine,
                        color: themes.whiteColor,
                        "&:hover": {
                          backgroundColor: themes.headLine,
                          color: themes.whiteColor,
                        },
                        borderRadius: "30px",
                        "&.Mui-selected": {
                          borderRadius: "30px",
                        },
                      },
                      "&:hover": {
                        backgroundColor:
                          loanScreen === "Apply"
                            ? themes.headLine
                            : themes.lightBrown,
                        color:
                          loanScreen === "Apply"
                            ? themes.whiteColor
                            : themes.headLine,
                      },
                      "&:focus": {
                        backgroundColor:
                          loanScreen === "Apply"
                            ? themes.headLine
                            : themes.lightBrown,
                        color:
                          loanScreen === "Apply"
                            ? themes.whiteColor
                            : themes.headLine,
                      },
                    }}
                    onClick={() => {
                      setSelectComponent("Apply");
                    }}
                  >
                    Apply
                  </Mui.ToggleButton>
                ) : null}
              </Mui.ToggleButtonGroup>
            </Mui.Box>
          </Mui.Grid>
          {selectComponent === "Approve" ? (
            <Mui.Grid item xs={2.2}></Mui.Grid>
          ) : (
            <Mui.Grid item xs={2.2}></Mui.Grid>
          )}
          <Mui.Grid
            item
            xs={2.4}
            sx={{
              padding: 1,
              display: "flex",
              flexDirection: "row",
              justifyContent: "end",
              alignItems: "flex-end",
            }}
          >
            {selectComponent === "Approve" || selectComponent === "History" ? (
              <CustomAutoComplete
                dataList={departmentData?.map((obj) => ({
                  ...obj,
                  label: obj.department_name,
                }))}
                selectedValue={departmentName}
                updateDataFunction={updateDepartmentName}
                placeHolder="Select department name"
                label="Select Department Name"
              />
            ) : null}
          </Mui.Grid>
          <Mui.Grid
            item
            xs={
              selectComponent === "Approve" || selectComponent === "History"
                ? 2.3
                : 2.4
            }
            sx={{ padding: 1 }}
          >
            {selectComponent === "Approve" || selectComponent === "History" ? (
              <CustomAutoCompleteWithLogo
                dataList={membersData?.map((obj) => ({
                  ...obj,
                  label: obj?.user_name,
                  image: obj?.image_url,
                }))}
                selectedValue={userName}
                updateDataFunction={updateUserName}
                placeHolder="Select employee name"
                label="Select User Name"
                showAvathar={showAutoCompleteAvathar}
                setShowAutoCompleteAvathar={setShowAutoCompleteAvathar}
              />
            ) : null}
          </Mui.Grid>
        </Mui.Grid>
      )}
      {viewLoan ? (
        <ViewLoan
          viewLoanDetails={viewLoanDetails}
          setViewLoan={setViewLoan}
          selectedComponent={selectComponent}
        />
      ) : showApprove ? (
        <ApproveLoan
          viewLoanDetails={viewLoanDetails}
          setShowApprove={setShowApprove}
          setUserChange={setUserChange}
          setDepartmentChange={setDepartmentChange}
        />
      ) : (
        renderComponent()
      )}
    </React.Fragment>
  );
};
